<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import service from '../../../../domain/usuarios/services'
  import * as Status from '../../../../domain/usuarios/helpers/PessoaStatus'

  export default {
    components: {},
    nome: 'usuario',
    directives: {mask},
    data () {
      return {
        data: null,
        saLogs: []
      }
    },
    computed: {
      apiUrl () {
        return process.env.API_URL
      },
      enderecoPrincipal () {
        if (this.data.pessoa.enderecos && this.data.pessoa.enderecos.length > 0) {
          let endereco = this.data.pessoa.enderecos.slice().shift()
          return [endereco]
        }
        return null
      },
      outrosEnderecos () {
        if (this.data.pessoa.enderecos && this.data.pessoa.enderecos.length > 1) {
          let enderecos = this.data.pessoa.enderecos.slice()
          enderecos.shift()
          return enderecos
        }
        return null
      },
      getEmails () {
        if (!this.data.pessoa.emails) {
          return 'Sem e-mail'
        }
        let emails = this.data.pessoa.emails.slice().map((e) => {
          return e.email
        })
        return emails.join(', ')
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados')
      service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.data = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      Status () {
        return Status
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      print: function () {
        window.print()
      },
      adjustFirstLetter (v) {
        return v.charAt(0).toLowerCase() + v.slice(1)
      },
      editar () {
        this.$router.push({name: 'usuario.editar', params: {id: this.data.id}})
      },
      deletar () {
        if (!window.confirm('Tem certeza que deseja remover este cadastro?')) {
          return
        }
        service.deletar(this.data.id)
          .then((response) => {
            alert('Deletado com sucesso!')
            this.$router.push({name: 'usuarios'})
          })
          .catch((error) => {
            alert('Não foi possível deletar')
            console.log(error)
          })
      },
      alterarSenha () {
        let senha = prompt('Qual a nova senha? Deixe em branco para gerar uma automaticamente.')
        if (senha === null) {
          return
        }
        if (typeof senha === 'undefined' || senha === '') {
          senha = Math.random().toString(36).slice(-8)
        }
        this.saLogs.push({message: 'Alterando senha...'})
        service.alterarSenha({password: senha}, this.data.id)
          .then((response) => {
            this.saLogs.push({message: '<span class="text-white">Senha alterada com sucesso!</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            this.saLogs.push({message: 'Nova senha: <span class="text-white">' + senha + '</span>'})
            this.saLogs.push({message: '--------------------------------------------------------'})
            console.log(response)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="data !== null" class="content-transition">
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-4">
              <!--<h1 class="m-n font-thin h3">#{{ data.apelido }}</h1>
              <h1 class="m-n font-thin h3">{{ data.pessoa.nome }}</h1>-->
              <h1 class="m-n font-thin h3">Usuário</h1>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success"></span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-8">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print"><i class="fa fa-print m-r-xs"></i> Imprimir
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editar">
                <i class="fa fa-edit m-r-xs"></i> Editar
              </u-button>
              <u-button class="btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print"
                        tabindex="1"
                        @click.prevent="deletar">
                <i class="fa fa-edit m-r-xs"></i> Deletar
              </u-button>
              <router-link :to="{name: 'usuarios'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">


          <div class="row">
            <div class="col-xs-6">
              <h4>{{ data.pessoa.nome }}</h4>
              <p>Login: {{ data.username }}</p>

              <p v-for="endereco in enderecoPrincipal">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }} {{ endereco.cep ? ', ' + endereco.cep : '' }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p class="b-t" v-for="endereco in outrosEnderecos">
                {{ endereco.logradouro }}{{ endereco.numero && ', ' + endereco.numero }} {{ endereco.complemento &&
                endereco.complemento}} <br>
                {{ endereco.bairro }}<br>
                {{ endereco.municipio ? endereco.municipio.nome : endereco.cidadeOutros }}, {{ endereco.municipio &&
                endereco.municipio.uf ? endereco.municipio.uf.nome : endereco.ufOutros }}
              </p>
              <p>
                <span v-for="telefone in data.pessoa.telefones">Telefone: {{ telefone.telefone | formataTelefone }}<i
                  v-if="telefone.celular" class="fa fa-mobile-phone m-l-xs"></i> <br></span>
              </p>
              <p>
                Email principal: <span>{{ data.email }}</span>
              </p>
              <p v-if="data.pessoa.emails && data.pessoa.emails.length > 0">
                Email{{ data.pessoa.emails && data.pessoa.emails.length > 1 ? 's' : '' }}: <span>{{ getEmails  }}</span>
              </p>
              <p>
                IP origem cadastro: <span>{{ data.pessoa.ipCadastro  }}</span>
              </p>
              <p v-if="data.pessoa.observacao">
                Observações:<br><br>
                {{ data.pessoa.observacao }}
              </p>
            </div>
            <div class="col-xs-6 text-right text-left-print">
              <p class="h4">#{{ data.id }}</p>
              <h5>Se cadastrou{{ data.pessoa.origem ? ' pelo ' + data.pessoa.origem.origem.toLowerCase() :
                '' }} {{ moment(data.pessoa.dataCadastro.date).format('LLLL') }}</h5>
              <div>
                {{ data.pessoa.tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica' }}<br>
                <div v-if="data.pessoa.tipo === 1">
                  CPF: <span v-if="data.pessoa.cpf">{{ data.pessoa.cpf | formataCpf }}</span><span v-else>Sem CPF</span><br>
                  RG: {{ data.pessoa.pfRg }} {{ data.pessoa.pfRgOrgaoEmissor }} {{
                  data.pessoa.pfRgDataExpedicao }}<br>
                  Nascimento: <span v-if="data.pessoa.pfDataNascimento">{{ moment(data.pessoa.pfDataNascimento.date).format('L') }}, {{data.pessoa.pfDataNascimento.date|moment}}</span><br>
                  Estado Civil: {{ Status().EstadoCivil[data.pessoa.pfEstadoCivil] }}<br>
                  Sexo: {{ data.pessoa.pfSexo === 1 ? 'Masculino' : 'Feminino' }}<br>
                  <div v-if="data.conjugeNome">
                    Cônjuge: {{ data.conjugeNome }}<br>
                    CPF Cônjuge: <span
                    v-if="data.conjugeCpf">{{ data.conjugeCpf | formataCpf }}</span><span
                    v-else>Sem CPF</span><br>
                    RG Cônjuge: <span v-if="data.conjugeRg">{{ data.conjugeRg }}</span><span
                    v-else>Sem RG</span><br>
                  </div>
                </div>
                <div v-if="data.pessoa.tipo === 2">
                  CNPJ: <span v-if="data.pessoa.cnpj">{{ data.pessoa.cnpj | formataCnpj }}</span><span
                  v-else>Sem CNPJ</span><br>
                  Inscrição Estadual: {{ data.pessoa.pjInscricaoEstadual }}<br>
                  Nome Fantasia: {{ data.pessoa.pjNomeFantasia }}<br>
                  Razão Social: {{ data.pessoa.pjRazaoSocial }}<br>
                  Responsável: {{ data.pessoa.pjResponsavel || data.pjProprietarioNome }}<br>
                  CPF: <span
                  v-if="data.pjProprietarioCpf">{{ data.pjProprietarioCpf | formataCpf }}</span><span
                  v-else>SEM CPF DO RESPONSÁVEL</span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <!-- LOGIN TIP -->
      <div class="wrapper">
        <div class="shell-wrap">
          <p class="shell-top-bar">Sistema de Acesso</p>
          <ul class="shell-body">
            <li>Login status: <span class="font-bold text-white">Active</span></li>
            <li>Username: <span class="font-bold text-white">{{ data.username }}</span></li>
            <li v-for="m in saLogs" v-html="m.message"></li>
          </ul>
        </div>
        <div class="m-t">
          <a class="btn btn-default" @click="alterarSenha">Alterar senha</a>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// VisualizarUsuario.vue?eeb983da